import { render, staticRenderFns } from "./PartnerLogins.vue?vue&type=template&id=6da30576&scoped=true"
import script from "./PartnerLogins.vue?vue&type=script&lang=js"
export * from "./PartnerLogins.vue?vue&type=script&lang=js"
import style0 from "./PartnerLogins.vue?vue&type=style&index=0&id=6da30576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da30576",
  null
  
)

export default component.exports